import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const dropngoBaseURL = () => {
  return APIHost() + "/general/admin/dropngo";
};

export const loadDropngoCategory = data => {
  const url = `${dropngoBaseURL()}/category/load`;
  return axios.post(url, data);
};

export const addDropngoCategory = data => {
  const url = `${dropngoBaseURL()}/category/create`;
  return axios.post(url, data);
};

export const editDropngoCategory = (id, data) => {
  const url = `${dropngoBaseURL()}/category/update/${id}`;
  return axios.post(url, data);
};

export const deleteDropngoCategory = (id, data) => {
  const url = `${dropngoBaseURL()}/category/remove/${id}`;
  return axios.post(url, data);
};


export const loadDropngoCategoryEffectiveDateList = (data) => {
  const url = `${dropngoBaseURL()}/price/effectiveDate`;
  return axios.post(url, data);
};

export const dropngoCategoryPriceControlLoad = (data) => {
  const url = `${dropngoBaseURL()}/priceControl/load`;
  return axios.post(url, data);
};

export const dropngoCategoryPriceControlSet = (id, data) => {
  const url = `${dropngoBaseURL()}/priceControl/set/${id}`;
  return axios.post(url, data);
};

export const dropngoCategoryPriceRemove = (id, data) => {
  const url = `${dropngoBaseURL()}/priceControl/remove/${id}`;
  return axios.post(url, data);
};

export const getDropngoCategoryPricePDF = data => {
  const url = `${dropngoBaseURL()}/price/pdf`;
  return axios.post(url, data);
};
